import images from "./images";

const menu = {
    espresso: [
        {
            id: 1,
            name: "Espresso",
            price: 12,
            description: "Rich, concentrated coffee shot, perfect for a quick caffeine boost.",
            image: images.espresso1,
            tags: []
        },
        {
            id: 2,
            name: "Latte",
            price: 10,
            description: "Creamy espresso drink with steamed milk, customizable with flavors.",
            image: images.espresso2,
            tags: ["sale"]
        },
        {
            id: 3,
            name: "Cappuccino",
            price: 9,
            description: "A balanced blend of espresso, steamed milk, and frothy foam.",
            image: images.espresso3,
            tags: []
        },
        {
            id: 4,
            name: "Americano",
            price: 15,
            description: "Classic espresso with hot water for a smooth, strong flavor.",
            image: images.espresso4,
            tags: []
        },
        {
            id: 5,
            name: "Mocha",
            price: 8,
            description: "Espresso combined with rich chocolate and steamed milk.",
            image: images.espresso5,
            tags: ["new"]
        },
        {
            id: 6,
            name: "ChocoMilk",
            price: 17,
            description: "Smooth, cold-steeped coffee served over ice.",
            image: images.espresso6,
            tags: []
        },
        {
            id: 7,
            name: "Black Coffee",
            price: 15,
            description: "Spiced chai tea concentrate with milk over ice",
            image: images.espresso7,
            tags: []
        },
        {
            id: 8,
            name: "Instant Coffee",
            price: 18,
            description: "Creamy espresso drink with steamed milk, customizable with flavors.",
            image: images.espresso8,
            tags: []
        }
    ],
    coldBrews: [
        {
            id: 1,
            name: "Iced Latte",
            price: 12,
            description: "Espresso and cold milk over ice, customizable with flavors.",
            image: images.coldBrew1,
            tags: []
        },
        {
            id: 2,
            name: "Iced Mocha",
            price: 7,
            description: "Cold espresso with chocolate syrup, milk, and ice.",
            image: images.coldBrew2,
            tags: []
        },
        {
            id: 3,
            name: "Brew",
            price: 9,
            description: "Smooth, cold-steeped coffee served over ice.",
            image: images.coldBrew3,
            tags: ["sale"]
        },
        {
            id: 4,
            name: "Iced Chai",
            price: 14,
            description: "Spiced chai tea concentrate with milk over ice.",
            image: images.coldBrew4,
            tags: ["new"]
        },
        {
            id: 5,
            name: "Iced Matcha",
            price: 10,
            description: "Earthy matcha green tea blended with milk over ice.",
            image: images.coldBrew5,
            tags: []
        },
        {
            id: 6,
            name: "Lemon Tea",
            price: 17,
            description: "Lemon Iced Tea – Refreshing black tea with a hint of lemon.",
            image: images.coldBrew6,
            tags: []
        },
        {
            id: 7,
            name: "Mango Tea",
            price: 20,
            description: "Blend of iced tea, mango, and lemonade for a fruity twist.",
            image: images.coldBrew7,
            tags: []
        },
        {
            id: 8,
            name: "Iced Macchiato",
            price: 13,
            description: "Layers of milk, espresso, and caramel ove",
            image: images.coldBrew8,
            tags: []
        }
    ],
    sweets: [
        {
            id: 1,
            name: "Croissant",
            price: 12,
            description: "Flaky, buttery pastry perfect with coffee.",
            image: images.sweet1,
            tags: []
        },
        {
            id: 2,
            name: "Muffin",
            price: 20,
            description: "Soft muffin bursting with fresh blueberries.",
            image: images.sweet2,
            tags: ["sale"]
        },
        {
            id: 3,
            name: "Biscotti",
            price: 12,
            description: "Crunchy Italian cookie ideal for dipping.",
            image: images.sweet3,
            tags: ["new"]
        },
        {
            id: 4,
            name: "CupCake",
            price: 16,
            description: "CupCake filled with rich chocolate.",
            image: images.sweet4,
            tags: []
        },
        {
            id: 5,
            name: "GF Brownie",
            price: 8,
            description: "Fudgy brownie, gluten-free.",
            image: images.sweet5,
            tags: []
        },
        {
            id: 6,
            name: "Doughnut",
            price: 9,
            description: "Soft and fluffy, topped with a sweet glaze or powdered sugar.",
            image: images.sweet6,
            tags: []
        },
        {
            id: 7,
            name: "Cheesecake",
            price: 20,
            description: "Creamy and rich, with a buttery graham cracker crust.",
            image: images.sweet7,
            tags: []
        },
        {
            id: 8,
            name: "ChocoCake",
            price: 15,
            description: "Moist and decadent, velvety chocolate frosting. A classic for chocolate lover.",
            image: images.sweet8,
            tags: []
        }
    ]

};

export default menu;